/**
 * Checks whether an agent presence has the phone channel enabled.
 *
 * @param presence Presence object
 * @returns Boolean
 */
export function isAgentAvailableOnPhoneChannel(presence) {
    return presence.working_channels.some(({ conversation_channel, working }) => conversation_channel === 'pstnphone' && working);
}
